import React, { useState } from "react";
import { Icon } from "../../icons/icons";
import FormField from "./FormField";
import FormOrderOptions from "./FormOrderOptions";
import { useRouter } from "next/router";
import { useTranslation } from "../../context/TranslationContext";

const FormOrder = ({ setParam }) => {
  const { SearchResultFilterOrderPlaceHolder, orderOptions } = useTranslation();
  const router = useRouter();
  const [order, setOrder] = useState(
    router.query.order_by ? router.query.order_by : 0
  );

  return (
    <FormField
      DropWrapperContent={FormOrderOptions}
      dropProps={{
        setParam: setParam,
        setOrder: setOrder,
        order: order,
        orderOptions: orderOptions,
      }}
    >
      <span className="font-semibold text-brand-gray-9 mr-3">
        <span className="hidden sm:inline-block">
          {SearchResultFilterOrderPlaceHolder} :{" "}
        </span>
        <span className="text-black text-sm">
          {orderOptions.find((x) => x.value == order).label}
        </span>
      </span>
      <Icon
        name={"ArrowDown"}
        className="group-hover:text-brand-color-primary"
      ></Icon>
    </FormField>
  );
};

export default FormOrder;
